import TabMenu from './Modules/TabMenu'

const initTabsOnLoad = function () {
    new TabMenu()
}

if (document.readyState !== 'loading') {
    initTabsOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initTabsOnLoad)
}
